// Pass-through. Per-operation password gating was removed per user request.
// The component still exists so call sites (Operations.js) don't need to be
// touched. It simply renders its children directly.
import React from "react";

export const OperationGuard = ({ children }) => <>{children}</>;
